import { produce } from 'immer';
import deviceType from 'ua-device-type';
import { PRODUCT_BOX_STYLE_TYPE } from 'b2b-components/theme/components/ProductList';
import { COMPARE_PRODUCTS_COOKIE_NAME } from 'b2b-apps/core/product/redux/productsCompare/types';
import { isServer } from 'b2b-apps/shop/common/utils/env';
import { getCookie } from 'b2b-apps/shop/common/utils/storage/cookies';
import { CLEAR_PRODUCTS_COMPARE } from 'b2b-apps/shop/product/redux/productsCompare/actionTypes';
import {
  CHANGE_PAGE_SIZE,
  CHANGE_SORTING,
  CHANGE_VIEW_TYPE,
  UPDATE_PRODUCTS_COMPARE_SETTINGS,
} from 'b2b-apps/shop/settings/redux/actionTypes';
import { getCookieSetting } from 'b2b-apps/shop/settings/redux/sagas';
import {
  PageSizeSettingType,
  SettingsActions,
  SettingsProductsCompareType,
  SettingsState,
  SortingSettingType,
  ViewTypeSettingType,
} from 'b2b-apps/shop/settings/redux/types';

export const DEFAULT_PER_PAGE: PageSizeSettingType = 48;
export const DEFAULT_SORT: SortingSettingType = 'rankasc';
export const DEFAULT_VIEW_TYPE: ViewTypeSettingType = PRODUCT_BOX_STYLE_TYPE.list;
const userAgent = !isServer ? window.navigator.userAgent : undefined;
const productsCompareCookie = getCookie(COMPARE_PRODUCTS_COOKIE_NAME) as SettingsProductsCompareType;
export const initialState: SettingsState = {
  deviceType: deviceType(userAgent),
  catalog: {
    viewType: getCookieSetting('viewType', DEFAULT_VIEW_TYPE),
    pageSize: getCookieSetting('pageSize', DEFAULT_PER_PAGE),
    sorting: getCookieSetting('sorting', DEFAULT_SORT),
  },
  productsCompare: {
    products: productsCompareCookie?.products || [],
    isClosed: !!productsCompareCookie?.isClosed || false,
  },
};

export const reducer = (
  state: SettingsState = initialState,
  action: SettingsActions,
): SettingsState => {
  switch (action.type) {
    case CHANGE_PAGE_SIZE:
      return produce(state, (draft: SettingsState) => {
        draft.catalog.pageSize = action.payload.pageSize;
      });

    case CHANGE_SORTING:
      return produce(state, (draft: SettingsState) => {
        draft.catalog.sorting = action.payload.sorting;
      });

    case CHANGE_VIEW_TYPE:
      return produce(state, (draft: SettingsState) => {
        draft.catalog.viewType = action.payload.viewType;
      });

    case UPDATE_PRODUCTS_COMPARE_SETTINGS:
      return produce(state, (draft) => {
        draft.productsCompare = {
          ...draft.productsCompare,
          ...action.payload.productsCompare,
        };
      });

    case CLEAR_PRODUCTS_COMPARE:
      return produce(state, (draft) => {
        draft.productsCompare = {
          products: [],
          isClosed: false,
        };
      });

    default:
      return state;
  }
};
